import { useStyle } from "./style";
import { PrimaryTable } from "@/components/tables/primary-table";
import { useQuotes } from "./use-quote";
import {
  GoMakeAlertModal,
  GoMakeDeleteModal,
  GoMakeModal,
  GomakeTextInput,
  ThreeOptionsModal,
  GoMakeDialog,
  GomakePrimaryButton,
} from "@/components";
import { DocumentsFilterSection } from "./components/documents-filter-section";
import { HeaderTitle } from "@/widgets";
import { DocumentLogsWidget } from "./widgets/documents-logs-widget/logs-widget";
import { InventoryIntakeModal } from "@/widgets/quote-new/modals-widgets/inventory-intake-modal";
import { PurchaseOrderTypeModal } from "@/widgets/quote-new/modals-widgets/purchase-order-type-modal";
import { DOCUMENT_TYPE } from "./enums";
import {
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { CardsSection } from "./widgets/statistics-section/statistics-sections";
import { GoMakePagination } from "@/components/pagination/gomake-pagination";
import { AddRuleModal } from "../products/profits-new/widgets/add-rule-modal";
import { useEffect, useRef } from "react";
import { ScheduledReportsTable } from "./widgets/scheduled-reports-table/scheduled-reports-table";
import { QuoteStatuses } from "@/widgets/quote-new/total-price-and-vat/enums";
import { OtherReasonModal } from "@/widgets/quote-new/total-price-and-vat/other-reason-modal";
import { CustomerCardWidget } from "@/widgets/customer-card-modal";
import { CLIENT_TYPE, CUSTOMER_ACTIONS } from "@/pages/customers/enums";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { CloseOrderNotesModal } from "../products/profits-new/widgets/close-order-notes-modal";
import { SendPaymentModal } from "./widgets/send-payment-modal/send-payment-modal";
import { MakePaymentModal } from "./widgets/make-payment-modal/make-payment-modal";
import { ExcelMenu } from "./widgets/excel-menu/excel-menu";
import { ModalType } from "@/enums";
import {
  ItemsCountIcon,
  PlusIcon,
  WalletIcon,
} from "./widgets/icons/header-section-icons";
import { TotalCardComponent } from "./widgets/statistics-section/total-card";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { Permissions } from "@/components/CheckPermission/enum";
import { PermissionCheck } from "@/components/CheckPermission";
import { PrimaryCheckbox } from "@/components/check-box/primary-check-box";
import { useDeliveryStatusButton } from "./widgets/delivery-status-button/use-delivery-status";
import { useClientContactsList } from "@/hooks/use-client-contacts";
import { UpdateDeliveryStatusModal } from "./widgets/delivery-status-button/delivery-status-modal/delivery-status-modal";
import CloseOrderNote from "./widgets/general/close-order-note";
import { PrintPackingSlipModal } from "../board-missions/widgets/print-packing-slip-modal";
import { DocumentsColumnSettingsMenu } from "./widgets/document-column-settings-menu/document-column-settings-menu";
import {
  getDocumentColumnKeys,
  getDocumentCustomWidth,
  parseSavedColumnSettings,
} from "./states/documents-columns-settings-state";
import { DocumentPrimaryTable } from "@/components/tables/document-primary-table";
import { getDocumentTableSettingsApi } from "@/services/api-service/generic-doc/documents-api";
import { ColumnSetting } from "@/widgets/production-floor/state/production-floor-coulmns-table-settings";
import { FONT_FAMILY } from "@/utils/font-family";
import { QR_CODE_LISTENER_FROM } from "@/hooks/use-qr-code-listener";
import QrCodeReader from "@/components/qr-code-reader";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { selectedItemsState } from "@/store";
import { FrontDeskEmailComposerWrapper } from "./components/frontdesk-email-composer-wrapper";
import { PrintPackingSlipModalWidget } from "@/widgets/production-floor/views/board-missions-view/navigation-buttons/print-packing-slip-modal-widget";
import { useParameters } from "@/hooks/use-parameters";
import { useTheme } from "@/contexts/theme";
import { usePrintHousePreferences } from "@/hooks/use-print-house-preferences";
import { EPreferences } from "@/enums/prefernces";
import { printHouseHasFrontDeskFeature } from "@/store/print-house-profile";
import { PurchaseOrdersDialogsUndoIntakeWidget } from "@/widgets/purchas-orders-dialogs/purchase-orders-dialogs-undo-intake-widget";
import { PurchaseOrdersDialogsIntakeValidationWidget } from "@/widgets/purchas-orders-dialogs/purchase-orders-dialogs-intake-validatin-widget";
import { AddAttachmentsModal } from "@/widgets/quote-new/modals-widgets/add-attachments-modal/add-attachments-modal";
import { AddButton } from "@/components/button/add-button";
import { useIsMobile } from "@/hooks/use-responsive";
import { CreateNewButton } from "./widgets/statistics-section/create-new-button";
import { ModernHomeDocList } from "@/themes/modern/components/modern-home-doc-list";

interface IProps {
  documentType: DOCUMENT_TYPE;
  isFromHomePage?: boolean;
  /** Home page only: "modern" renders the filterable/paginated customer list. */
  homeVariant?: "classic" | "modern";
}

const QuotesListPageWidget = ({
  documentType,
  isFromHomePage = false,
  homeVariant = "classic",
}: IProps) => {
  const isModernHome = isFromHomePage && homeVariant === "modern";
  const { classes } = useStyle();
  const router = useRouter();
  const isMobile = useIsMobile();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  const isModernQuotes = currentTheme === "modern" && !isFromHomePage;
  const { CheckPreferenceValue } = usePrintHousePreferences();
  const showCustomerSupportRepresentative = !!CheckPreferenceValue(
    EPreferences.SHOW_CUSTOMER_SUPPORT_REPRESENTATIVE,
  );
  const hasFrontDeskFeature = useRecoilValue(printHouseHasFrontDeskFeature);
  const { getClientContacts, clientContacts } = useClientContactsList();
  const {
    onClickCloseModal,
    setPatternSearch,
    patternSearch,
    setStatusId,
    setCustomerId,
    setAgentId,
    setCustomerSupportRepresentativeId,
    renderOptions,
    checkWhatRenderArray,
    updateQuoteStatus,
    onClickSearchFilter,
    onClickClearFilter,
    onClickCloseLogsModal,
    setPage,
    onclickCreateNew,
    t,
    handlePageSizeChange: handleQuotesPageSizeChange,
    handleCardClick,
    handleSecondCardClick,
    onCloseAddRuleModal,
    onOpenAddRuleModal,
    openFilterConfirmationModal,
    onCloseFilterConfirmationModal,
    onContinueWithFilters,
    onResetFiltersAndGenerate,
    openScheduledReportsModal,
    onShowScheduledReports,
    onCloseScheduledReportsModal,
    onToggleScheduledReportActive,
    onDeleteScheduledReport,
    navigate,
    onClickQuotePdf,
    allQuotes,
    quoteStatuses,
    agentsCategories,
    customerSupportRepresentativesCategories,
    openModal,
    statusId,
    customerId,
    agentId,
    customerSupportRepresentativeId,
    openLogsModal,
    logsModalTitle,
    logsTableHeaders,
    documentLabel,
    allDocuments,
    tableHomeHeader,
    pagesCount,
    page,
    allStatistics,
    pageSize,
    activeCard,
    openAddRule,
    documentPath,
    onSelectDeliveryTimeDates,
    employeeId,
    handleSelectEmployee,
    resetLogsDatePicker,
    onSelectDateRange,
    onClickSearchLogsFilter,
    onClickClearLogsFilter,
    documentLogsData,
    handleMaxPriceChange,
    handleMinPriceChange,
    minPrice,
    maxPrice,
    handleMultiSelectChange,
    productIds,
    printHouseMaterialIds,
    setPrintHouseMaterialIds,
    productsList,
    getAllProducts,
    accountingStatuses,
    accountingStatus,
    productionStatuses,
    productionStatus,
    handleProductionStatusChange,
    handleAccountingStatusChange,
    handleClick,
    handleClose,
    open,
    anchorEl,
    filterData,
    filterDTO,
    updateCancelQuote,
    openIrrelevantCancelModal,
    onClickCloseIrrelevantModal,
    openPriceCancelModal,
    openDeliveryTimeCancelModal,
    onClickCloseDeliveryTimeModal,
    openDuplicateCancelModal,
    onClickCloseDuplicateModal,
    onClickClosePriceModal,
    openOtherReasonModal,
    onClickCloseOtherReasonModal,
    onClickCancelOffer,
    setReasonText,
    showCustomerModal,
    customerForEdit,
    setCustomerForEdit,
    setShowCustomerModal,
    setIsCanceledState,
    isCanceledState,
    openCloseOrderNotesModal,
    onClickCloseCloseOrderNotesModal,
    onClickCloseOrderCallback,
    selectedQuoteItemValue,
    paymentModalTitle,
    openPaymentModal,
    onClickClosePaymentModal,
    onClickCloseCloseOrderModal,
    openCloseOrderModal,
    selectedDocument,
    onClickOpenCloseOrderModal,
    ManuallyCloseDocument,
    documentCloseNumber,
    handleDocumentNumberChange,
    approvalStatuses,
    setApprovalStatusId,
    approvalStatusId,
    openMakePaymentModal,
    onClickCloseMakePaymentModal,
    isOrdersTracking,
    onClickCloseTrackModal,
    openCloseAndTrackOrderModal,
    closeAndTrackOrder,
    onClickClosePrintPDFModal,
    openPrintPDFModal,
    fromDate,
    toDate,
    checkFromDate,
    checkToDate,
    onSelectCheckDueDateRange,
    getAllQuotes,
    openCancelReceiptModal,
    onCloseCancelReceiptModal,
    onClickCancelReceipt,
    openCancelReceiptModalRefund,
    onCloseCancelReceiptModalRefund,
    ExportDocumentTableToExcel,
    ExportOrderItemsTableToExcel,
    isFetching,
    openChangeProductionStatusModal,
    isSelectedCLoseAsDeliveryNote,
    isSelectedCLoseAsProformaInvoice,
    onClickCloseChangeProductionStatusModal,
    moveOrderToReady,
    onChangeDocumentSearch,
    isPausedOrders,
    setIsPausedOrders,
    isOrdersWithoutJobs,
    setIsOrdersWithoutJobs,
    openDuplicateModal,
    onCloseDuplicateModal,
    onClickDocumentDuplicate,
    searchInputRef,
    openExportReceiptPdfModal,
    onCloseExportReceiptPdfModal,
    startOrderProduction,
    openStartProductionModal,
    onClickCloseStartProductionModal,
    getValueByKey,
    isOrder,
    isQuote,
    isDeliveryNote,
    isProformaInvoice,
    isInvoice,
    deliveryStatuses,
    deliveryStatus,
    setDeliveryStatus,
    setFromDate,
    setToDate,
    isPurchaseDocument,
    isSendToClient,
    isReceipt,
    isSupplierPayments,
    isPurchaseOrder,
    openInventoryIntakeModal,
    onClickCloseInventoryIntakeModal,
    inventoryData,
    inventoryLoading,
    selectedDocument: selectedInventoryDocument,
    showIntakeValidationDialog,
    handleOpenIntakeFromValidation,
    handleCancelIntakeValidation,
    handleUndoDocumentIntake,
    handleUndoItemIntake,
    showUndoIntakeDialog,
    handleConfirmUndoIntake,
    handleCancelUndoIntake,
    isMoveToReady,
    handleCheckboxChange,
    handleSortBE,
    isDescOrderBE,
    isHeaderSortable,
    onClickCloseReopenDocumentModal,
    openReopenDocModal,
    OpenDocument,
    deliveryOrderId,
    deliveryOrderNumber,
    deliveryCustomerId,
    isSendOrderReadyToClient,
    alertNotVerifiedMailModal,
    alertNotVerifiedModalState,
    showAlertModal,
    handleRemoveDraftBtnClick,
    removeDraftModal,
    onCloseOpenRemoveDraftModal,
    MoveOrderToReady,
    onClickPrintPackagingSlip,
    handleQuantityPerPackageChange,
    handleQuantityOfPackagesChange,
    quantityPerPackage,
    quantityOfPackages,
    renderPackageInput,
    onClosePackagesModal,
    openPackagesModal,
    openPrintExportModal,
    setOpenPrintExportModal,
    exportPdf,
    printPackingSlip,
    isPrintHouseHasPackagingSlipPrinter,
    paymentType,
    handlePaymentTypeChange,
    typeOfPayments,
    initialPageSize,
    ExportDocumentTableToPdf,
    tableKey,
    visibleHeaders,
    columnsReady,
    setColumnsReady,
    setColumnOrder,
    setColumnVisibility,
    callApi,
    onClickCloseMoveOrderToReadyModal,
    onClickOpenMoveOrderToReadyModal,
    moveToReadyOption,
    handleRadioChange,
    primaryColor,
    currencyFilter,
    setCurrencyFilter,
    currencies,
    isDocumentTableLoading,
    isDocumentTableError,
    isSocketRefreshingDocuments,
    scheduledReports,
    totalCount: scheduledReportsTotalCount,
    pageNumber: scheduledReportsPageNumber,
    pagesCountScheduledReports: scheduledReportsPagesCount,
    isLoading: scheduledReportsIsLoading,
    createScheduledReport,
    handlePageChange: handleScheduledReportsPageChange,
    handlePageSizeChangeScheduledReports: handleScheduledReportsPageSizeChange,
    openPurchaseOrderTypeModal,
    onOpenPurchaseOrderTypeModal,
    onClosePurchaseOrderTypeModal,
    handleSelectPurchaseOrderType,
    isEmailComposerOpen,
    emailData,
    isLoadingEmailData,
    closeEmailComposer,
    openEmailComposer,
    documentForEmail,
    isFromPaymentPage,
    hideCheckboxes,
    preSelectedMethod,
    // Upload files modal
    openUploadFileModal,
    onCloseUploadFilesModal,
    onClickOpenUploadFilesModal,
    quoteForUploadModal,
    getQuoteForUploadModal,
    // Modern home list
    tableHomeHeaderModern,
    homePageSize,
    homePagesCount,
    homeTotalItems,
    handleHomePageSizeChange,
    homeStatusOptions,
    homeStatusValue,
    setHomeStatus,
    applyHomeSearch,
    onSelectHomeDates,
    setHomeProducts,
    clearHomeFilters,
    hasHomeFilters,
  } = useQuotes(documentType, isFromHomePage, homeVariant);

  // Use page size of 10 for scheduled reports
  const scheduledReportsPageSize = 10;

  const {
    openDeliveryModal,
    onCloseDeliveryModal,
    renderTableRows,
    editableQuantities,
    setEditableQuantities,
    setDocumentItems,
    getDocumentDeliveryItems,
    selectedItem,
    removeDocumentDeliveryItem,
    onCloseDeleteModal,
    openDeleteModal,
  } = useDeliveryStatusButton();

  //! I think we don't need this
  useEffect(() => {
    if (router.query.orderNumber) {
      setPatternSearch(router.query.orderNumber as string);
    } else if (router.query.documentNumber) {
      setPatternSearch(router.query.documentNumber as string);
    }
  }, [router]);
  useEffect(() => {
    if (router.query.isComeFromQR) {
      getDocumentDeliveryItems(DOCUMENT_TYPE.order, router.query.orderId);
      getClientContacts(router.query.clientId);
    }
  }, [router]);

  useEffect(() => {
    (!isFromHomePage || isModernHome) && getAllProducts();
  }, []);

  const dir: "rtl" | "ltr" = t("direction");
  const RTL = dir === "rtl";

  const renderCreateNewButton = (onClickHandler) => {
    const button = isHpClient ? (
      <AddButton label={t("sales.quote.createNew")} onClick={onClickHandler} />
    ) : (
      <Button
        className={isModernQuotes && !isMobile ? "gm-ql-create" : undefined}
        sx={{
          ...classes.createNewDocument,
          // Shares the mobile title row with the page heading.
          ...(isMobile && { flexShrink: 0, whiteSpace: "nowrap" }),
          "& .MuiButton-startIcon": {
            ...(RTL
              ? { marginLeft: "4px", marginRight: 0 }
              : { marginRight: "4px", marginLeft: 0 }),
          },
        }}
        onClick={onClickHandler}
        startIcon={<PlusIcon stroke={primaryColor(500)} />}
      >
        {t("sales.quote.createNew")}
      </Button>
    );

    // Orders header "create new" also calls create-new-document with quote type.
    if (isOrder) {
      return (
        <PermissionCheck userPermission={Permissions.CREATE_QUOTES}>
          {button}
        </PermissionCheck>
      );
    }

    return button;
  };

  // Non-quote documents each open creation differently.
  const onClickCreateNewDocument = isOrder
    ? onclickCreateNew
    : isSupplierPayments
      ? () => navigate(`/${documentPath}`)
      : isPurchaseOrder
        ? () => {
            setSelectedItems([]);
            onOpenPurchaseOrderTypeModal();
          }
        : () => {
            setSelectedItems([]);
            navigate(`/${documentPath}?isNewCreation=true`);
          };

  // Modern desktop: summary cards use the production-floor KPI look.
  const useKpiCards = isModernQuotes && !isMobile;

  const renderOrderCard = (onclickCreateNew, showCreateNew = true) => {
    const summaryCards = allQuotes ? (
      <>
        <TotalCardComponent
          text={`${t("sales.list.totalItemsCounts", {
            documentType: t(`sales.list.${DOCUMENT_TYPE[documentType]}`),
          })}`}
          number={allStatistics?.totalItems}
          icon={useKpiCards ? <Inventory2OutlinedIcon /> : <ItemsCountIcon />}
          variant={useKpiCards ? "kpi" : undefined}
          tone="ink"
        />
        <TotalCardComponent
          text={t("sales.quote.totalPrice")}
          number={getValueByKey(
            allStatistics?.documentStatisticsList,
            "totalPrice",
          )}
          icon={
            useKpiCards ? <AccountBalanceWalletOutlinedIcon /> : <WalletIcon />
          }
          withCurrency={true}
          variant={useKpiCards ? "kpi" : undefined}
          tone="time"
        />
      </>
    ) : (
      <>
        <Skeleton variant="rectangular" sx={classes.skeltonStyle} />
        <Skeleton variant="rectangular" sx={classes.skeltonStyle} />
      </>
    );

    return (
      <>
        <PermissionCheck
          userPermission={Permissions.SHOW_ERP_DOCUMENTS_TABLE_SUMMERY}
        >
          {useKpiCards ? (
            <div className="gm-pf-kpis">{summaryCards}</div>
          ) : (
            summaryCards
          )}
        </PermissionCheck>

        {showCreateNew && renderCreateNewButton(onclickCreateNew)}
      </>
    );
  };

  const handleOpenDeliveryModal = (documentId) => {
    getDocumentDeliveryItems(documentType, documentId);
    getClientContacts(deliveryCustomerId);
  };

  const handleCloseDeliveryModal = () => {
    onCloseDeliveryModal();
    router.push(router.pathname, undefined, { shallow: true });
  };

  useEffect(() => {
    if (deliveryOrderId) {
      handleOpenDeliveryModal(deliveryOrderId);
    }
  }, [router.query.deliveryOrderId]);

  useEffect(() => {
    const loadDocumentColumnSettings = async () => {
      try {
        const res = await getDocumentTableSettingsApi(callApi, () => {}, {
          documentType,
        });
        const saved: ColumnSetting[] = res?.data;
        const allColumnKeys = getDocumentColumnKeys(
          tableKey,
          showCustomerSupportRepresentative,
        );

        if (saved && saved.length > 0) {
          const { order, visibility } = parseSavedColumnSettings(
            saved,
            allColumnKeys,
          );
          if (
            allColumnKeys.includes("estimatedProductionDate") &&
            !saved.some((column) => column?.key === "estimatedProductionDate")
          ) {
            visibility.estimatedProductionDate = true;
          }
          setColumnOrder(order);
          setColumnVisibility(visibility);
        } else {
          setColumnOrder(allColumnKeys);
          setColumnVisibility(
            Object.fromEntries(
              allColumnKeys.map((key) => [
                key,
                key === "termOfPayment" ? false : true,
              ]),
            ),
          );
        }
      } catch (error) {
        console.error("Failed to load document column settings", error);
      } finally {
        setColumnsReady(true);
      }
    };

    loadDocumentColumnSettings();
  }, [documentType, tableKey, showCustomerSupportRepresentative]);
  const setSelectedItems = useSetRecoilState(selectedItemsState);
  const { parametersStateValue } = useParameters();

  return (
    <>
      {!isFromHomePage && (
        <Stack
          direction="column"
          justifyContent="space-between"
          display="flex"
          height="100%"
        >
          <QrCodeReader qrCodeListenerFrom={QR_CODE_LISTENER_FROM.QUOTES} />
          <div
            className={isModernQuotes ? "gm-ql" : undefined}
            style={classes.mainContainer}
          >
            {/* header section */}
            <div
              className={isModernQuotes ? "gm-ql-header" : undefined}
              style={classes.headerStyle}
            >
              {isMobile ? (
                <div style={classes.mobileTitleRowStyle}>
                  <HeaderTitle
                    title={documentLabel}
                    marginTop={1}
                    marginBottom={1}
                  />
                  {isQuote ? (
                    <CreateNewButton onClick={onclickCreateNew} compact />
                  ) : (
                    !isOrdersTracking &&
                    renderCreateNewButton(onClickCreateNewDocument)
                  )}
                </div>
              ) : (
                !isModernQuotes && (
                  <HeaderTitle
                    title={documentLabel}
                    marginTop={1}
                    marginBottom={1}
                  />
                )
              )}
              <div
                className={isModernQuotes ? "gm-ql-header-end" : undefined}
                style={classes.rowStyle}
              >
                {isQuote && (
                  <CardsSection
                    statistics={allStatistics?.documentStatisticsList}
                    activeCard={activeCard}
                    onClick={onclickCreateNew}
                    onClickCard={handleCardClick}
                    onSecondClickCard={handleSecondCardClick}
                    showCreateNew={!isMobile}
                  />
                )}

                {!isQuote &&
                  !isOrdersTracking &&
                  renderOrderCard(onClickCreateNewDocument, !isMobile)}
              </div>
            </div>
            {/* Filters Section */}
            <DocumentsFilterSection
              customerId={customerId}
              setCustomerId={setCustomerId}
              renderOptions={renderOptions}
              checkWhatRenderArray={checkWhatRenderArray}
              isFetching={isFetching}
              isPurchaseDocument={isPurchaseDocument}
              agentId={agentId}
              setAgentId={setAgentId}
              agentsCategories={agentsCategories}
              customerSupportRepresentativeId={customerSupportRepresentativeId}
              setCustomerSupportRepresentativeId={
                setCustomerSupportRepresentativeId
              }
              customerSupportRepresentativesCategories={
                customerSupportRepresentativesCategories
              }
              printHouseMaterialIds={printHouseMaterialIds}
              setPrintHouseMaterialIds={setPrintHouseMaterialIds}
              isQuote={isQuote}
              statusId={statusId}
              setStatusId={setStatusId}
              setPage={setPage}
              quoteStatuses={quoteStatuses}
              approvalStatusId={approvalStatusId}
              setApprovalStatusId={setApprovalStatusId}
              approvalStatuses={approvalStatuses}
              isOrder={isOrder}
              productionStatus={productionStatus}
              handleProductionStatusChange={handleProductionStatusChange}
              productionStatuses={productionStatuses}
              accountingStatus={accountingStatus}
              handleAccountingStatusChange={handleAccountingStatusChange}
              accountingStatuses={accountingStatuses}
              isDeliveryNote={isDeliveryNote}
              isInvoice={isInvoice}
              isProformaInvoice={isProformaInvoice}
              deliveryStatus={deliveryStatus}
              setDeliveryStatus={setDeliveryStatus}
              deliveryStatuses={deliveryStatuses}
              documentType={documentType}
              DOCUMENT_TYPE={DOCUMENT_TYPE}
              handleMultiSelectChange={handleMultiSelectChange}
              productsList={productsList}
              productIds={productIds}
              currencyFilter={currencyFilter}
              setCurrencyFilter={setCurrencyFilter}
              currencies={currencies}
              isPurchaseOrder={isPurchaseOrder}
              isCanceledState={isCanceledState}
              setIsCanceledState={setIsCanceledState}
              isReceipt={isReceipt}
              isSupplierPayments={isSupplierPayments}
              paymentType={paymentType}
              handlePaymentTypeChange={handlePaymentTypeChange}
              typeOfPayments={typeOfPayments}
              isPausedOrders={isPausedOrders}
              setIsPausedOrders={setIsPausedOrders}
              isOrdersWithoutJobs={isOrdersWithoutJobs}
              setIsOrdersWithoutJobs={setIsOrdersWithoutJobs}
              minPrice={minPrice}
              maxPrice={maxPrice}
              handleMinPriceChange={handleMinPriceChange}
              handleMaxPriceChange={handleMaxPriceChange}
              fromDate={fromDate}
              toDate={toDate}
              onSelectDeliveryTimeDates={onSelectDeliveryTimeDates}
              checkFromDate={checkFromDate}
              checkToDate={checkToDate}
              onSelectCheckDueDateRange={onSelectCheckDueDateRange}
              patternSearch={patternSearch}
              onChangeDocumentSearch={onChangeDocumentSearch}
              onClickClearFilter={onClickClearFilter}
              onClickSearchFilter={onClickSearchFilter}
              columnsReady={columnsReady}
              tableKey={tableKey}
              onOpenAddRuleModal={onOpenAddRuleModal}
              ExportDocumentTableToExcel={ExportDocumentTableToExcel}
              ExportOrderItemsTableToExcel={ExportOrderItemsTableToExcel}
              ExportDocumentTableToPdf={ExportDocumentTableToPdf}
              DocumentsColumnSettingsMenu={DocumentsColumnSettingsMenu}
              ExcelMenu={ExcelMenu}
              classes={classes}
            />
            {/* document table */}
            <>
              {columnsReady ? (
                <DocumentPrimaryTable
                  stickyFirstCol={false}
                  stickyHeader={true}
                  maxHeight={"calc(100vh - 265px)"}
                  rows={allQuotes}
                  headers={visibleHeaders}
                  withSortBE={true}
                  onClickSortBE={handleSortBE}
                  isDescOrderBE={isDescOrderBE}
                  isHeaderSortable={isHeaderSortable}
                  docType={documentType}
                  columnWidths={visibleHeaders.map((key) =>
                    getDocumentCustomWidth(tableKey, key, isHpClient),
                  )}
                  loading={isDocumentTableLoading}
                  error={isDocumentTableError}
                  disableSkeleton={isSocketRefreshingDocuments}
                  emptyState={{
                    title: `${t("general.tableEmptyStateTitle", {
                      document: t(
                        `sales.list.${DOCUMENT_TYPE[documentType]}`,
                      ).toLowerCase(),
                    })}`,
                    description: `${t("general.tableEmptyStateDescription", {
                      document: t(
                        `sales.list.${DOCUMENT_TYPE[documentType]}`,
                      ).toLowerCase(),
                    })}`,
                  }}
                />
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                >
                  <CircularProgress />
                </Box>
              )}
            </>
          </div>
          <GoMakePagination
            onChangePageNumber={(event, value) => {
              setPage(value);
              router.push({
                pathname: router.pathname,
                query: { ...router.query, pageNumber: value },
              });
            }}
            onChangePageSize={handleQuotesPageSizeChange}
            page={page}
            setPage={setPage}
            pagesCount={pagesCount}
            pageSize={pageSize}
            router={router}
            isFromDocumentsOrJobs={true}
            initialPageSize={initialPageSize}
          />
        </Stack>
      )}
      {isModernHome && (
        <ModernHomeDocList
          documentType={documentType}
          rows={allDocuments}
          headers={tableHomeHeaderModern}
          isLoading={isDocumentTableLoading}
          page={page}
          setPage={setPage}
          pageSize={homePageSize}
          pagesCount={homePagesCount}
          totalItems={homeTotalItems}
          onChangePageSize={handleHomePageSizeChange}
          onSearch={applyHomeSearch}
          searchValue={patternSearch}
          fromDate={fromDate}
          toDate={toDate}
          onSelectDates={onSelectHomeDates}
          statusOptions={homeStatusOptions}
          statusValue={homeStatusValue}
          onChangeStatus={setHomeStatus}
          productsList={productsList}
          productIds={productIds}
          onChangeProducts={setHomeProducts}
          hasFilters={hasHomeFilters}
          onClearFilters={clearHomeFilters}
          onCreateNew={onclickCreateNew}
          onExportTable={ExportDocumentTableToExcel}
          onExportOrderItems={
            documentType === DOCUMENT_TYPE.order
              ? ExportOrderItemsTableToExcel
              : undefined
          }
        />
      )}
      {isFromHomePage && !isModernHome && (
        <PrimaryTable
          stickyHeader={true}
          // maxHeight={"calc(100vh)"}
          rows={allDocuments}
          headers={tableHomeHeader}
          variant="OddEvenTable"
          withoutShadow={true}
          columnWidths={tableHomeHeader.map((_, i) =>
            i === tableHomeHeader.length - 1
              ? isHpClient
                ? "1%"
                : undefined
              : undefined,
          )}
          columnAlignments={tableHomeHeader.map((_, i) =>
            i === tableHomeHeader.length - 1 ? "center" : undefined,
          )}
          emptyState={{
            title: `${t("general.tableEmptyStateTitle", {
              document: t(
                `sales.list.${DOCUMENT_TYPE[documentType]}`,
              ).toLowerCase(),
            })}`,
          }}
        />
      )}
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("sales.quote.titleModal")}
        subTitle={t("sales.quote.subTitleModal")}
        yesBtn={t("sales.quote.changeStatus")}
        openModal={openModal}
        onClose={onClickCloseModal}
        onClickDelete={() => updateQuoteStatus()}
      />
      <GoMakeModal
        insideStyle={classes.insideStyle}
        openModal={openLogsModal}
        onClose={onClickCloseLogsModal}
        modalTitle={logsModalTitle}
      >
        <DocumentLogsWidget
          employeeId={employeeId}
          handleSelectEmployee={handleSelectEmployee}
          onClickClearLogsFilter={onClickClearLogsFilter}
          onClickSearchLogsFilter={onClickSearchLogsFilter}
          resetLogsDatePicker={resetLogsDatePicker}
          onSelectDateRange={onSelectDateRange}
          logsTableHeaders={logsTableHeaders}
          logsTableRows={documentLogsData}
        />
      </GoMakeModal>
      {!isFromHomePage && (
        <AddRuleModal
          openModal={openAddRule}
          onCloseModal={onCloseAddRuleModal}
          isQuoteWidge={true}
          filterData={filterData}
          filterDTO={filterDTO}
          documentType={documentType}
          onShowScheduledReports={onShowScheduledReports}
          createScheduledReport={createScheduledReport}
          parametersStateValue={parametersStateValue}
        />
      )}
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("sales.list.filterConfirmationTitle")}
        subTitle={t(" ")}
        yesBtn={t("sales.list.continueWithCurrentFilters")}
        cancelBtn={t("sales.list.resetFiltersAndGenerate")}
        openModal={openFilterConfirmationModal}
        onClose={onCloseFilterConfirmationModal}
        onClickDelete={onContinueWithFilters}
        onClickCancel={onResetFiltersAndGenerate}
        style={{ width: "35%" }}
      />
      <ScheduledReportsTable
        openModal={openScheduledReportsModal}
        onCloseModal={onCloseScheduledReportsModal}
        scheduledReports={scheduledReports || []}
        totalCount={scheduledReportsTotalCount}
        pageNumber={scheduledReportsPageNumber}
        pageSize={scheduledReportsPageSize}
        pagesCount={scheduledReportsPagesCount}
        isLoading={scheduledReportsIsLoading}
        onToggleActive={onToggleScheduledReportActive}
        onDelete={onDeleteScheduledReport}
        onPageChange={handleScheduledReportsPageChange}
        onPageSizeChange={handleScheduledReportsPageSizeChange}
      />
      <GoMakeDeleteModal
        modalType={ModalType.EDIT}
        title={t("sales.quote.titleCancelModal")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openIrrelevantCancelModal}
        onClose={onClickCloseIrrelevantModal}
        subTitle={`${t("sales.quote.subTitleCancelModal", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        cancelBtn={t("sales.quote.noBtn")}
        onClickDelete={() =>
          updateCancelQuote(QuoteStatuses.CANCELED_IRRELEVANT)
        }
      />
      <GoMakeDeleteModal
        modalType={ModalType.EDIT}
        title={t("sales.quote.titleCancelModal")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openPriceCancelModal}
        onClose={onClickClosePriceModal}
        subTitle={`${t("sales.quote.subTitleCancelModal", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        cancelBtn={t("sales.quote.noBtn")}
        onClickDelete={() => updateCancelQuote(QuoteStatuses.CANCELED_PRICE)}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("sales.quote.titleCloseModal")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openCloseOrderModal}
        onClose={onClickCloseCloseOrderModal}
        subTitle={`${t("sales.quote.subTitleCloseModal", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}?`}
        onClickDelete={() => ManuallyCloseDocument(selectedDocument)}
        style={{ width: "35%" }}
      >
        <GomakeTextInput
          style={{ height: "40px", minWidth: 180 }}
          placeholder={t("sales.enterDocumentNumber")}
          value={documentCloseNumber}
          onChange={handleDocumentNumberChange}
        />
      </GoMakeDeleteModal>
      <GoMakeDeleteModal
        modalType={ModalType.EDIT}
        title={t("sales.quote.titleCancelModal")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openDeliveryTimeCancelModal}
        onClose={onClickCloseDeliveryTimeModal}
        subTitle={`${t("sales.quote.subTitleCancelModal", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        cancelBtn={t("sales.quote.noBtn")}
        onClickDelete={() =>
          updateCancelQuote(QuoteStatuses.CANCELED_DELIVERY_TIME)
        }
      />
      <GoMakeDeleteModal
        modalType={ModalType.EDIT}
        title={t("sales.quote.titleCancelModal")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openDuplicateCancelModal}
        onClose={onClickCloseDuplicateModal}
        subTitle={`${t("sales.quote.subTitleCancelModal", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        cancelBtn={t("sales.quote.noBtn")}
        onClickDelete={() =>
          updateCancelQuote(QuoteStatuses.CANCELED_DUPLICATE)
        }
      />
      <OtherReasonModal
        openModal={openOtherReasonModal}
        onClose={onClickCloseOtherReasonModal}
        setReasonText={setReasonText}
        onClickCancelOffer={onClickCancelOffer}
      />
      <CustomerCardWidget
        customerAction={CUSTOMER_ACTIONS.Edit}
        codeFlag={true}
        typeClient={
          isPurchaseDocument && !isPurchaseOrder
            ? CLIENT_TYPE.SUPPLIER
            : CLIENT_TYPE.CUSTOMER
        }
        isgetAllCustomers={false}
        openModal={showCustomerModal}
        onClose={() => setShowCustomerModal(false)}
        customer={customerForEdit}
        setCustomer={setCustomerForEdit}
      />
      <CloseOrderNotesModal
        onClose={onClickCloseCloseOrderNotesModal}
        openModal={openCloseOrderNotesModal}
        quoteItemValue={selectedQuoteItemValue}
        onClickCloseOrder={onClickCloseOrderCallback}
      />
      <SendPaymentModal
        openPaymentModal={openPaymentModal}
        onClickClosePaymentModal={onClickClosePaymentModal}
        paymentModalTitle={paymentModalTitle}
        documentType={documentType}
        isSendToClient={isSendToClient}
        isSendOrderReadyToClient={isSendOrderReadyToClient}
        showAlertModal={showAlertModal}
        hideCheckboxes={hideCheckboxes}
        preSelectedMethod={preSelectedMethod}
        onOpenEmailComposer={openEmailComposer}
        documentForEmail={documentForEmail}
      />
      <GoMakeAlertModal
        openModal={alertNotVerifiedMailModal.isOpen}
        onClose={() => {
          alertNotVerifiedMailModal.close();
        }}
        onClickConfirm={() => {
          alertNotVerifiedModalState.onConfirm?.();
          alertNotVerifiedMailModal.close();
        }}
        subTitle={alertNotVerifiedModalState.message}
        withCancelBtn={!!alertNotVerifiedModalState.onConfirm}
      />
      <MakePaymentModal
        openMakePaymentModal={openMakePaymentModal}
        onClickCloseMakePaymentModal={onClickCloseMakePaymentModal}
        orderItemValue={selectedQuoteItemValue}
        getAllQuotes={getAllQuotes}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("sales.closeAndTrackTitle")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openCloseAndTrackOrderModal}
        onClose={onClickCloseTrackModal}
        onClickDelete={closeAndTrackOrder}
        style={{ width: "35%" }}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("sales.quote.printDeliveryNoteWithPrices")}
        openModal={openPrintPDFModal}
        yesBtn={t("sales.quote.yesBtn")}
        cancelBtn={t("sales.quote.noBtn")}
        onClose={onClickClosePrintPDFModal}
        hideIcon
        onClickDelete={() => {
          onClickQuotePdf(selectedDocument?.id, true);
        }}
        onClickCancel={() => {
          onClickQuotePdf(selectedDocument?.id, false);
        }}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("payment.cancelReceipt")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openCancelReceiptModal}
        onClose={onCloseCancelReceiptModal}
        onClickDelete={onClickCancelReceipt}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={
          isSelectedCLoseAsDeliveryNote
            ? "customers.modal.closeOrderAsDeliveryNote"
            : isSelectedCLoseAsProformaInvoice
              ? "customers.modal.closeOrderAsProformaInvoice"
              : "customers.modal.closeOrderAsInvoice"
        }
        subTitle={"customers.modal.thisOrderIsAlreadyInProcess"}
        yesBtn={
          isSelectedCLoseAsDeliveryNote
            ? t("customers.modal.closeAsDeliveryNote")
            : isSelectedCLoseAsProformaInvoice
              ? t("customers.modal.closeAsProformaInvoice")
              : t("customers.modal.closeAsInvoice")
        }
        openModal={openChangeProductionStatusModal}
        onClose={onClickCloseChangeProductionStatusModal}
        onClickDelete={() => {
          if (isMoveToReady) {
            moveOrderToReady(
              moveToReadyOption === "withMessage" ? true : false,
            );
          } else {
            if (isSelectedCLoseAsDeliveryNote) {
              const path = `/deliveryNote?isNewCreation=true&orderId=${selectedDocument?.id}`;
              window.open(path, "_blank");
            } else if (isSelectedCLoseAsProformaInvoice) {
              const path = isOrder
                ? `/proformaInvoice?isNewCreation=true&orderId=${selectedDocument?.id}`
                : `/proformaInvoice?isNewCreation=true&deliveryNoteId=${selectedDocument?.id}`;
              window.open(path, "_blank");
            } else {
              const path = isOrder
                ? `/invoice?isNewCreation=true&orderId=${selectedDocument?.id}`
                : `/invoice?isNewCreation=true&deliveryNoteId=${selectedDocument?.id}`;
              window.open(path, "_blank");
            }
          }
        }}
      >
        <Stack alignItems={"center"} spacing={2}>
          <div
            style={{
              ...classes.inputLbl,
              color: isMoveToReady ? "black" : "#475467",
            }}
          >
            <PrimaryCheckbox
              checked={isMoveToReady}
              onChange={handleCheckboxChange}
            />
            {t("sales.moveToReadyAndCloseOrder")}
          </div>
          {isMoveToReady && (
            <RadioGroup
              row
              value={moveToReadyOption}
              onChange={handleRadioChange}
              style={{ marginTop: 8 }}
            >
              <FormControlLabel
                value="withoutMessage"
                control={
                  <Radio
                    sx={{ transform: "scale(0.8)", p: 0.5 }}
                    style={{ color: primaryColor(300) }}
                  />
                }
                label={t("sales.moveToReadyWithoutMessage")}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    ...FONT_FAMILY.Lexend(500, 13),
                  },
                }}
              />
              <FormControlLabel
                value="withMessage"
                control={
                  <Radio
                    sx={{ transform: "scale(0.8)", p: 0.5 }}
                    style={{ color: primaryColor(300) }}
                  />
                }
                label={t("sales.moveToReadyWithMessage")}
                sx={{
                  "& .MuiFormControlLabel-label": {
                    ...FONT_FAMILY.Lexend(500, 13),
                  },
                }}
              />
            </RadioGroup>
          )}
          <CloseOrderNote note={selectedDocument?.closeOrderNotes} />
        </Stack>
      </GoMakeDeleteModal>
      <ThreeOptionsModal
        title={t("payment.cancelReceipt")}
        yesBtn={t("payment.CancelWithRefund")}
        noBtn={t("payment.CancelWithoutRefund")}
        openModal={openCancelReceiptModalRefund}
        onClose={onCloseCancelReceiptModalRefund}
        onClickYes={() => {
          onClickCancelReceipt(true);
          onCloseCancelReceiptModalRefund();
        }}
        onClickNo={() => {
          onClickCancelReceipt(false);
          onCloseCancelReceiptModalRefund();
        }}
      />
      <ThreeOptionsModal
        modalType={ModalType.DUPLICATE}
        title={t("boardMissions.duplicateModalTitle")}
        yesBtn={"boardMissions.duplicateModalYes"}
        noBtn={"boardMissions.duplicateModalNo"}
        openModal={openDuplicateModal}
        onClose={onCloseDuplicateModal}
        onClickYes={() => onClickDocumentDuplicate(selectedDocument?.id, true)}
        onClickNo={() => onClickDocumentDuplicate(selectedDocument?.id, false)}
      />
      <ThreeOptionsModal
        title={t("sales.modals.printReceipt")}
        subTitle={t("sales.modals.includeInvoicesPdfPrompt")}
        yesBtn={"sales.modals.withInvoices"}
        noBtn={"sales.modals.withoutInvoices"}
        openModal={openExportReceiptPdfModal}
        onClose={onCloseExportReceiptPdfModal}
        onClickYes={() => onClickQuotePdf(selectedDocument?.id, false, true)}
        onClickNo={() => onClickQuotePdf(selectedDocument?.id, false, false)}
        hideIcon
      />
      <GoMakeDeleteModal
        hideIcon
        title={t("sales.tables.startProduction")}
        yesBtn={t("sales.quote.yesBtn")}
        openModal={openStartProductionModal}
        onClose={onClickCloseStartProductionModal}
        subTitle={t("sales.modals.confirmSendToProduction")}
        onClickDelete={startOrderProduction}
      />
      <GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={`${t("sales.quote.ReopenModalTitle", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        openModal={openReopenDocModal}
        onClose={onClickCloseReopenDocumentModal}
        subTitle={`${t("sales.quote.ReopenModalSubTitle", {
          documentName: t(
            `sales.quote.${DOCUMENT_TYPE[documentType]}`,
          ).toLowerCase(),
        })}`}
        onClickDelete={() => OpenDocument(selectedDocument)}
        style={{ width: "35%" }}
        yesBtn={t("sales.quote.yesBtn")}
      />
      {/* Delivery Modal */}
      <UpdateDeliveryStatusModal
        openModal={openDeliveryModal}
        onCloseModal={handleCloseDeliveryModal}
        document={document}
        documentItems={renderTableRows()}
        editableQuantities={editableQuantities}
        setEditableQuantities={setEditableQuantities}
        setDocumentItems={setDocumentItems}
        clientContacts={clientContacts}
        documentType={documentType}
        documentId={deliveryOrderId?.toString()}
        documentNumber={deliveryOrderNumber?.toString()}
        onClickOpenMoveOrderToReadyModal={onClickOpenMoveOrderToReadyModal}
        getAllQuotes={getAllQuotes}
      />
      <GoMakeDeleteModal
        modalType={ModalType.DELETE}
        openModal={openDeleteModal}
        onClose={onCloseDeleteModal}
        onClickDelete={() => removeDocumentDeliveryItem(selectedItem)}
      />
      <GoMakeDeleteModal
        modalType={ModalType.DELETE}
        openModal={removeDraftModal.isOpen}
        onClose={onCloseOpenRemoveDraftModal}
        onClickDelete={handleRemoveDraftBtnClick}
      />
      {/* <GoMakeDeleteModal
        modalType={ModalType.EDIT}
        title={t("sales.moveToReadyAndCloseOrder")}
        openModal={MoveOrderToReady.isOpen}
        onClose={onClickCloseMoveOrderToReadyModal}
        onClickDelete={moveOrderToReady}
      /> */}
      <ThreeOptionsModal
        modalType={ModalType.WARNING}
        title={t("boardMissions.markDoneModalTitle")}
        subTitle={t("boardMissions.markDoneModalSubTitle")}
        yesBtn={"boardMissions.markDoneModalYes"}
        noBtn={"boardMissions.markDoneModalNo"}
        openModal={MoveOrderToReady.isOpen}
        onClose={onClickCloseMoveOrderToReadyModal}
        onClickYes={() => moveOrderToReady(true)}
        onClickNo={() => moveOrderToReady(false)}
      />
      {/*<GoMakeDeleteModal
        modalType={ModalType.WARNING}
        title={t("boardMissions.markDoneModalTitle")}
        subTitle={t("boardMissions.markDoneModalSubTitle")}
        yesBtn={t("modal.confirm")}
        openModal={MoveOrderToReady.isOpen}
        onClose={onClickCloseMoveOrderToReadyModal}
        onClickDelete={() => moveOrderToReady()}
        onClickCancel={onClickCloseMoveOrderToReadyModal}
      />*/}
      <PrintPackingSlipModal
        openPackagesModal={openPackagesModal}
        onClosePackagesModal={onClosePackagesModal}
        renderPackageInput={renderPackageInput}
        quantityOfPackages={quantityOfPackages}
        quantityPerPackage={quantityPerPackage}
        handleQuantityOfPackagesChange={handleQuantityOfPackagesChange}
        handleQuantityPerPackageChange={handleQuantityPerPackageChange}
        onClickConfirm={onClickPrintPackagingSlip}
        openPrintExportModal={openPrintExportModal}
        setOpenPrintExportModal={setOpenPrintExportModal}
        exportPdf={exportPdf}
        printPackingSlip={printPackingSlip}
        isPrintHouseUsePrintNode={isPrintHouseHasPackagingSlipPrinter}
      />
      <PurchaseOrderTypeModal
        open={openPurchaseOrderTypeModal}
        onClose={onClosePurchaseOrderTypeModal}
        onSelectProduct={() => handleSelectPurchaseOrderType(false)}
        onSelectMaterial={() => handleSelectPurchaseOrderType(true)}
      />
      <InventoryIntakeModal
        open={openInventoryIntakeModal}
        onClose={onClickCloseInventoryIntakeModal}
        inventoryData={inventoryData}
        loading={inventoryLoading}
        purchaseOrderId={selectedInventoryDocument?.id}
        documentType={DOCUMENT_TYPE.purchaseOrder}
        status={selectedInventoryDocument?.status}
        onIntakeSuccess={getAllQuotes}
      />
      {/* FrontDesk Email Composer */}
      {isEmailComposerOpen && documentForEmail?.id && (
        <FrontDeskEmailComposerWrapper
          open={isEmailComposerOpen}
          onClose={closeEmailComposer}
          emailData={emailData}
          documentId={documentForEmail.id}
          documentType={
            isFromPaymentPage ? (18 as DOCUMENT_TYPE) : documentType
          }
          isLoading={isLoadingEmailData}
        />
      )}
      {/* Intake Validation Dialog */}
      <PurchaseOrdersDialogsIntakeValidationWidget
        showIntakeValidationDialog={showIntakeValidationDialog}
        handleCancelIntakeValidation={handleCancelIntakeValidation}
        handleOpenIntakeFromValidation={handleOpenIntakeFromValidation}
      />
      {/* Undo Intake Dialog - when changing from Received status */}
      <PurchaseOrdersDialogsUndoIntakeWidget
        showUndoIntakeDialog={showUndoIntakeDialog}
        handleCancelUndoIntake={handleCancelUndoIntake}
        handleConfirmUndoIntake={handleConfirmUndoIntake}
      />
      {/* Upload Files Modal */}
      <AddAttachmentsModal
        openModal={openUploadFileModal}
        onClose={onCloseUploadFilesModal}
        documentType={documentType}
        getQuote={getQuoteForUploadModal}
        isQuoteConfirmation={false}
        quoteConfirm={quoteForUploadModal}
      />
    </>
  );
};

export { QuotesListPageWidget };
